import { Box, Button, CircularProgress, Stack, Typography } from "@mui/joy";
import React, { useEffect, useRef, useState } from "react";
import useGetDeviceInfo from "hooks/useGetDeviceInfo";
import { theme } from "styles/theme";
import ContentTemplateV2 from "../content/ContentTemplateV2";
import image19 from "static/image/payment/typec/660_19.png";
import image20 from "static/image/payment/typec/660_20.png";
import FloatingAreaPromotion from "../../common/FloatingAreaPromotion";
import CustomTypography from "../../common/CustomTypography";
import image1 from "../../../static/image/payment/typec/660_1.png";
import image2 from "../../../static/image/payment/typec/660_2.png";
import image3 from "../../../static/image/payment/typec/660_3.png";
import image4 from "../../../static/image/payment/typec/660_4.png";
import image5 from "../../../static/image/payment/typec/660_5.png";
import image6 from "../../../static/image/payment/typec/660_6.png";
import image7 from "../../../static/image/payment/typec/660_7.png";
import image8 from "../../../static/image/payment/typec/660_8.gif";
import image9 from "../../../static/image/payment/typec/660_9.png";
import image10 from "../../../static/image/payment/typec/660_10.png";
import image11 from "../../../static/image/payment/typec/660_11.png";
import image12 from "../../../static/image/payment/typec/660_12.png";
import image13 from "../../../static/image/payment/typec/660_13.png";
import image14 from "../../../static/image/payment/typec/660_14.png";
import image15 from "../../../static/image/payment/typec/660_15.png";
import image16 from "../../../static/image/payment/typec/660_16.png";
import image17 from "../../../static/image/payment/typec/660_17.png";
import image18 from "../../../static/image/payment/typec/660_18.png";
import checkIconImg from "../../../static/image/payment/Check.svg";

import useMixpanelMKT from "../../../hooks/useMixpanelMKT";
import { useNavigate } from "react-router-dom";
import { PATH } from "../../../routes/paths";
import { useRecoilState, useRecoilValue } from "recoil";
import { userSimpleAtom } from "../../../recoil/userSimpleAtom";
import useAutoLoginPromotion from "../../../hooks/useAutoLoginPromotion";
import useFetchUserPromotion from "../../../hooks/useFetchUserPromotion";
import {
  ONBOARDING_QA_DETAIL_DEFAULT,
  OnboardingQADetailType,
} from "api/onboardingApi";
import { onboardingPromotionDataState } from "../../../recoil/onboardingPromotionDataAtom";
import { goal2OptionList } from "../../../pages/onboarding/partPromotion/goal/Goal_2_MultiSelect_1_Promotion";
import { goal3OptionList } from "../../../pages/onboarding/partPromotion/goal/Goal_3_MultiSelect_2_Promotion";
import { goal5OptionList } from "../../../pages/onboarding/partPromotion/goal/Goal_5_Promotion";
import { motivation7OptionList } from "../../../pages/onboarding/partPromotion/motivation/Motivation_7_MultiSelect_Promotion";
import CheckIcon from "../../icons/CheckIcon";
import { UpArrowSvg } from "../../../static/image/common/SvgAssets";
import numWithCircle1NewImg from "../../../static/image/payment/NumWithCircle_1_new.svg";
import numWithCircle2NewImg from "../../../static/image/payment/NumWithCircle_2_new.svg";
import { attachEulLeul } from "../../../utils/koreanUtils";
import numWithCircle1Img from "../../../static/image/payment/NumWithCircle_1.svg";
import numWithCircle2Img from "../../../static/image/payment/NumWithCircle_2.svg";
import numWithCircle3Img from "../../../static/image/payment/NumWithCircle_3.svg";
import numWithCircle4Img from "../../../static/image/payment/NumWithCircle_4.svg";
import numWithCircle5Img from "../../../static/image/payment/NumWithCircle_5.svg";
import { webTestTypeAtom } from "../../../recoil/webTestTypeAtom";

const numberWithCircleNew = [numWithCircle1NewImg, numWithCircle2NewImg];
const numberWithCircle = [
  numWithCircle1Img,
  numWithCircle2Img,
  numWithCircle3Img,
  numWithCircle4Img,
  numWithCircle5Img,
];

const majorTrainingPlan = [
  "내적 변화를 알아차리기",
  "주의력을 통제하며 경험을 분리하기",
  "생각을 심리적 사건으로 바라보기",
  "회피하지 않고 기꺼이 받아들이기",
  "삶의 가치를 향해 전념하기",
];

const programFeatures = [
  {
    main: "인지심리학 핵심 이론",
  },
  {
    main: "전담 코치의 1:1 지원",
  },
  {
    main: "감정, 신체 안정화 도구",
  },
  {
    main: "기술 연습을 위한 명상",
  },
  {
    main: "실생활 적용을 위한 기록지",
  },
];

export default function ProductContentPromotion() {
  const floatingAreaRef = useRef<HTMLDivElement>(null);
  const fullWidth = true;
  const isInappWebview = true;

  const webTestType = useRecoilValue(webTestTypeAtom);

  const [user, setUser] = useRecoilState(userSimpleAtom);
  const { isChecking } = useAutoLoginPromotion();
  const { isFetching } = useFetchUserPromotion();

  const navigate = useNavigate();

  const trackPromotion = useMixpanelMKT({
    eventName: "상품 상세 페이지 진입",
    version: "v4",
  });

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  const viewContentSent = useRef(false);

  useEffect(() => {
    if (isChecking || isFetching) return;
    if (viewContentSent.current) return;

    viewContentSent.current = true;

    trackPromotion();
  }, [isChecking, isFetching, user, trackPromotion]);

  const { homeIndicatorHeight } = useGetDeviceInfo();
  const [containerHeight, setContainerHeight] = useState<number>(
    window.innerHeight - homeIndicatorHeight
  );
  const [floatingAreaHeight, setFloatingAreaHeight] = useState<number>(0);

  const promotionData = useRecoilValue(onboardingPromotionDataState);

  const processSelection = (
    key: string,
    optionList: { id: number; text: string }[]
  ) => {
    const data = promotionData[key];
    if (!data) return null;

    const selectedIds = new Set<number>();
    if (data.multiSelectionIdList) {
      data.multiSelectionIdList.forEach((id) => selectedIds.add(id));
    }
    if (data.singleSelectionId) {
      selectedIds.add(data.singleSelectionId);
    }

    if (selectedIds.size === 0) return null;

    const sortedIds = Array.from(selectedIds).sort((a, b) => a - b);

    const collected = sortedIds
      .map((id) => optionList.find((opt) => opt.id === id)?.text)
      .filter((text): text is string => !!text);

    if (collected.length === 0) return null;

    let filtered = [...collected];
    if (filtered.length >= 2 && filtered.includes("기타")) {
      filtered = filtered.filter((t) => t !== "기타");
    }

    const transformed = filtered.map((text) => {
      if (key === "goal_3") {
        return text === "기타" ? "여러 외부적 요인" : text;
      } else if (key === "goal_5") {
        if (text.includes("잘 모르겠음")) {
          return "부정적";
        } else {
          return text.replace(/\s*\(.*\)/, "").trim();
        }
      }
      return text;
    });

    const joined = transformed.join(", ");
    return joined.trim() === "" ? null : joined;
  };

  const onboardingQADetailState: OnboardingQADetailType = {
    pageGoal2Answer:
      processSelection("goal_2", goal2OptionList) ??
      ONBOARDING_QA_DETAIL_DEFAULT.pageGoal2Answer,
    pageGoal3Answer:
      processSelection("goal_3", goal3OptionList) ??
      ONBOARDING_QA_DETAIL_DEFAULT.pageGoal3Answer,
    pageGoal5Answer:
      processSelection("goal_5", goal5OptionList) ??
      ONBOARDING_QA_DETAIL_DEFAULT.pageGoal5Answer,
    motivation7Answer:
      processSelection("motivation_7", motivation7OptionList) ??
      ONBOARDING_QA_DETAIL_DEFAULT.motivation7Answer,
  };

  const SESSION_OPEN_WEEKS_KEY = "payment.openWeeks.100dayABC";
  const [openWeeks, setOpenWeeks] = useState<Record<number, boolean>>(() => {
    try {
      if (typeof window !== "undefined") {
        const saved = sessionStorage.getItem(SESSION_OPEN_WEEKS_KEY);
        if (saved) {
          return JSON.parse(saved);
        }
      }
    } catch {}
    return { 0: true };
  });

  useEffect(() => {
    try {
      if (typeof window !== "undefined") {
        sessionStorage.setItem(
          SESSION_OPEN_WEEKS_KEY,
          JSON.stringify(openWeeks)
        );
      }
    } catch {}
  }, [openWeeks]);

  const toggleWeek = (index: number) => {
    setOpenWeeks((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  // 영역 1: ~님의 프로그램 섹션 (온보딩 기반)
  const programSectionWithOnboarding = (
    <Stack
      spacing={5}
      justifyContent="center"
      alignItems={"center"}
      sx={{
        width: "100%",
        maxWidth: "100%",
        mx: "auto",
        pt: 6,
        px: isInappWebview ? 3.5 : 6,
        pb: 8,
      }}
    >
      <Stack
        spacing={3}
        sx={{
          width: "100%",
          maxWidth: "660px",
          textAlign: "center",
        }}
      >
        <CustomTypography
          variant={"H1"}
          sx={{
            paddingTop: "12px",
            color: theme.vars.palette.Content.Strong,
            fontWeight: 800,
          }}
        >
          {user?.nickname ? `${user.nickname}님의 프로그램` : "나의 프로그램"}
        </CustomTypography>
        <Typography
          variant={"Subtitle"}
          sx={{
            color: theme.vars.palette.Content.Medium,
            fontWeight: 500,
          }}
        >
          {"나와 유사한 40만 개의 데이터 포인트로 생성한 맞춤 프로그램입니다."}
        </Typography>
      </Stack>

      <Stack
        spacing={"12px"}
        sx={{
          width: "100%",
          maxWidth: "660px",
        }}
      >
        {/*1-2주차*/}
        <Box
          sx={{
            backgroundColor: theme.vars.palette.Surface.Forward,
            borderRadius: "16px",
            py: "14px",
            px: "20px",
          }}
        >
          <Stack spacing={1}>
            <Stack
              direction="row"
              spacing="8px"
              alignItems="center"
              onClick={() => {
                toggleWeek(0);
              }}
              sx={{ height: "36px", cursor: "pointer" }}
            >
              <Box
                sx={{
                  ...(!openWeeks[0] && {
                    transform: "rotate(-90deg)",
                    transformOrigin: "center",
                  }),
                  transition: "transform 0.2s",
                }}
              >
                <UpArrowSvg color={theme.vars.palette.Content.Strong} />
              </Box>
              <CustomTypography
                variant={"Body"}
                sx={{
                  p: 0,
                  color: theme.vars.palette.Content.Strong,
                  fontWeight: 700,
                }}
              >
                {`1-2주차`}
              </CustomTypography>
            </Stack>

            {openWeeks[0] && (
              <>
                <Stack spacing={2} sx={{ pb: 1 }}>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <img
                      src={numberWithCircleNew[0]}
                      alt={"number"}
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`${onboardingQADetailState?.pageGoal3Answer}에 내가 어떻게 괴로워지는지 패턴을 발견합니다.`}
                    </CustomTypography>
                  </Stack>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <img
                      src={numberWithCircleNew[1]}
                      alt={"number"}
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`내게 ${onboardingQADetailState?.pageGoal5Answer} 반응을 일으키는 자동적 사고를 찾아봅니다.`}
                    </CustomTypography>
                  </Stack>

                  <CustomTypography
                    variant={"Body"}
                    sx={{
                      px: 0.2,
                      color: theme.vars.palette.Content.Highlight,
                      fontWeight: 700,
                    }}
                  >
                    이 시점에 가능해지는 것
                  </CustomTypography>

                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <CheckIcon
                      ariaLabel="included"
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`내가 왜 힘든지 막연함 없이 말로 설명할 수 있게 됩니다.`}
                    </CustomTypography>
                  </Stack>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <CheckIcon
                      ariaLabel="included"
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`감정에 휩쓸리기 전에 한 박자 멈추는 순간이 생기기 시작합니다.`}
                    </CustomTypography>
                  </Stack>
                </Stack>
              </>
            )}
          </Stack>
        </Box>

        {/*3-4주차*/}
        <Box
          sx={{
            backgroundColor: theme.vars.palette.Surface.Forward,
            borderRadius: "16px",
            py: "14px",
            px: "20px",
          }}
        >
          <Stack spacing={1}>
            <Stack
              direction="row"
              spacing="8px"
              alignItems="center"
              onClick={() => {
                toggleWeek(1);
              }}
              sx={{ height: "36px", cursor: "pointer" }}
            >
              <Box
                sx={{
                  ...(!openWeeks[1] && {
                    transform: "rotate(-90deg)",
                    transformOrigin: "center",
                  }),
                  transition: "transform 0.2s",
                }}
              >
                <UpArrowSvg color={theme.vars.palette.Content.Strong} />
              </Box>
              <CustomTypography
                variant={"Body"}
                sx={{
                  p: 0,
                  color: theme.vars.palette.Content.Strong,
                  fontWeight: 700,
                }}
              >
                {`3-4주차`}
              </CustomTypography>
            </Stack>

            {openWeeks[1] && (
              <>
                <Stack spacing={2} sx={{ pb: 1 }}>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <img
                      src={numberWithCircleNew[0]}
                      alt={"number"}
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`${onboardingQADetailState?.pageGoal5Answer} 반응을 야기하는 자동적 사고를 한 걸음 떨어져 바라보는 연습을 합니다.`}
                    </CustomTypography>
                  </Stack>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <img
                      src={numberWithCircleNew[1]}
                      alt={"number"}
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`생각의 내용을 여러 각도에서 따져보며, 그에 반드시 반응할 필요가 없다는 경험을 쌓아갑니다.`}
                    </CustomTypography>
                  </Stack>

                  <CustomTypography
                    variant={"Body"}
                    sx={{
                      px: 0.2,
                      color: theme.vars.palette.Content.Highlight,
                      fontWeight: 700,
                    }}
                  >
                    이 시점에 가능해지는 것
                  </CustomTypography>

                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <CheckIcon
                      ariaLabel="included"
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`생각이 떠올라도 예전만큼 즉각 반응하지 않게 됩니다.`}
                    </CustomTypography>
                  </Stack>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <CheckIcon
                      ariaLabel="included"
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`나의 마음을 바라보는 메타인지가 강화되기 시작합니다.`}
                    </CustomTypography>
                  </Stack>
                </Stack>
              </>
            )}
          </Stack>
        </Box>

        {/*5-6주차*/}
        <Box
          sx={{
            backgroundColor: theme.vars.palette.Surface.Forward,
            borderRadius: "16px",
            py: "14px",
            px: "20px",
          }}
        >
          <Stack spacing={1}>
            <Stack
              direction="row"
              spacing="8px"
              alignItems="center"
              onClick={() => {
                toggleWeek(2);
              }}
              sx={{ height: "36px", cursor: "pointer" }}
            >
              <Box
                sx={{
                  ...(!openWeeks[2] && {
                    transform: "rotate(-90deg)",
                    transformOrigin: "center",
                  }),
                  transition: "transform 0.2s",
                }}
              >
                <UpArrowSvg color={theme.vars.palette.Content.Strong} />
              </Box>
              <CustomTypography
                variant={"Body"}
                sx={{
                  p: 0,
                  color: theme.vars.palette.Content.Strong,
                  fontWeight: 700,
                }}
              >
                {`5-6주차`}
              </CustomTypography>
            </Stack>

            {openWeeks[2] && (
              <>
                <Stack spacing={2} sx={{ pb: 1 }}>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <img
                      src={numberWithCircleNew[0]}
                      alt={"number"}
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`여러 ${onboardingQADetailState?.pageGoal5Answer} 반응에 대해 알아차리고, 분리하고, 따져보는 연습을 계속해 나갑니다.`}
                    </CustomTypography>
                  </Stack>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <img
                      src={numberWithCircleNew[1]}
                      alt={"number"}
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`그 과정에서 회피하거나 싸우지 않고, 있는 그대로를 수용하는 법을 배웁니다.`}
                    </CustomTypography>
                  </Stack>

                  <CustomTypography
                    variant={"Body"}
                    sx={{
                      px: 0.2,
                      color: theme.vars.palette.Content.Highlight,
                      fontWeight: 700,
                    }}
                  >
                    이 시점에 가능해지는 것
                  </CustomTypography>

                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <CheckIcon
                      ariaLabel="included"
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`힘든 감정이 와도 예전처럼 버겁게 느껴지지 않습니다.`}
                    </CustomTypography>
                  </Stack>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <CheckIcon
                      ariaLabel="included"
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`감정과 생각을 없애려 애쓰지 않고 그와 공존할 수 있는 여유를 갖게 됩니다.`}
                    </CustomTypography>
                  </Stack>
                </Stack>
              </>
            )}
          </Stack>
        </Box>

        {/*7-8주차*/}
        <Box
          sx={{
            backgroundColor: theme.vars.palette.Surface.Forward,
            borderRadius: "16px",
            py: "14px",
            px: "20px",
          }}
        >
          <Stack spacing={1}>
            <Stack
              direction="row"
              spacing="8px"
              alignItems="center"
              onClick={() => {
                toggleWeek(3);
              }}
              sx={{ height: "36px", cursor: "pointer" }}
            >
              <Box
                sx={{
                  ...(!openWeeks[3] && {
                    transform: "rotate(-90deg)",
                    transformOrigin: "center",
                  }),
                  transition: "transform 0.2s",
                }}
              >
                <UpArrowSvg color={theme.vars.palette.Content.Strong} />
              </Box>
              <CustomTypography
                variant={"Body"}
                sx={{
                  p: 0,
                  color: theme.vars.palette.Content.Strong,
                  fontWeight: 700,
                }}
              >
                {`7-8주차`}
              </CustomTypography>
            </Stack>

            {openWeeks[3] && (
              <>
                <Stack spacing={2} sx={{ pb: 1 }}>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <img
                      src={numberWithCircleNew[0]}
                      alt={"number"}
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`${onboardingQADetailState?.motivation7Answer !== "기타" ? `${onboardingQADetailState?.motivation7Answer}처럼 내 삶에서 정말 중요한 것들을 돌아봅니다.` : "내 삶에서 정말 중요한 것들을 돌아봅니다."}`}
                    </CustomTypography>
                  </Stack>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <img
                      src={numberWithCircleNew[1]}
                      alt={"number"}
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`${onboardingQADetailState?.pageGoal5Answer} 반응 속에서도 ${attachEulLeul(onboardingQADetailState?.pageGoal2Answer ?? "")} 향해 방향을 잡는 법을 배웁니다.`}
                    </CustomTypography>
                  </Stack>

                  <CustomTypography
                    variant={"Body"}
                    sx={{
                      px: 0.2,
                      color: theme.vars.palette.Content.Highlight,
                      fontWeight: 700,
                    }}
                  >
                    이 시점에 가능해지는 것
                  </CustomTypography>

                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <CheckIcon
                      ariaLabel="included"
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`기분에 휘둘리지 않고 주체적인 선택을 내리는 순간이 늘어납니다.`}
                    </CustomTypography>
                  </Stack>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <CheckIcon
                      ariaLabel="included"
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`어떻게 살아가고 싶은지를 기준으로 행동하기 시작합니다.`}
                    </CustomTypography>
                  </Stack>
                </Stack>
              </>
            )}
          </Stack>
        </Box>

        {/*9주차 이상*/}
        <Box
          sx={{
            backgroundColor: theme.vars.palette.Surface.Forward,
            borderRadius: "16px",
            py: "14px",
            px: "20px",
          }}
        >
          <Stack spacing={1}>
            <Stack
              direction="row"
              spacing="8px"
              alignItems="center"
              onClick={() => {
                toggleWeek(4);
              }}
              sx={{ height: "36px", cursor: "pointer" }}
            >
              <Box
                sx={{
                  ...(!openWeeks[4] && {
                    transform: "rotate(-90deg)",
                    transformOrigin: "center",
                  }),
                  transition: "transform 0.2s",
                }}
              >
                <UpArrowSvg color={theme.vars.palette.Content.Strong} />
              </Box>
              <CustomTypography
                variant={"Body"}
                sx={{
                  p: 0,
                  color: theme.vars.palette.Content.Strong,
                  fontWeight: 700,
                }}
              >
                {`9주차 이상`}
              </CustomTypography>
            </Stack>

            {openWeeks[4] && (
              <>
                <Stack spacing={2} sx={{ pb: 1 }}>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <img
                      src={numberWithCircleNew[0]}
                      alt={"number"}
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`배운 디스턴싱 기술들을 부드럽게 연결하여 삶 속에 적용하는 연습을 계속해나갑니다.`}
                    </CustomTypography>
                  </Stack>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <img
                      src={numberWithCircleNew[1]}
                      alt={"number"}
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`마음속 깊은 곳을 살펴보며, 어린 시절의 경험들이 지금의 나에게 어떤 영향을 주고 있는지 이해합니다.`}
                    </CustomTypography>
                  </Stack>

                  <CustomTypography
                    variant={"Body"}
                    sx={{
                      px: 0.2,
                      color: theme.vars.palette.Content.Highlight,
                      fontWeight: 700,
                    }}
                  >
                    이 시점에 가능해지는 것
                  </CustomTypography>

                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <CheckIcon
                      ariaLabel="included"
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`내 마음을 하나의 흐름으로 이해할 수 있게 됩니다.`}
                    </CustomTypography>
                  </Stack>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems="flex-start"
                    sx={{ pr: "10px" }}
                  >
                    <CheckIcon
                      ariaLabel="included"
                      style={{ marginTop: "0.5px" }}
                    />
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 500,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "normal",
                        lineBreak: "auto",
                      }}
                    >
                      {`스스로를 소중히 여기며 돌보는 태도가 자리 잡기 시작합니다.`}
                    </CustomTypography>
                  </Stack>
                </Stack>
              </>
            )}
          </Stack>
        </Box>
      </Stack>
      <Stack
        sx={{
          width: "100%",
          maxWidth: "660px",
          textAlign: "center",
        }}
      >
        <CustomTypography
          variant={"Caption"}
          sx={{
            color: theme.vars.palette.Content.Medium,
            fontWeight: 500,
          }}
        >
          {
            "* 선택한 플랜과 참여도에 따라 진행 속도는 달라질 수 있으며, 세부 내용은 코치와 함께 세밀하게 조정됩니다."
          }
        </CustomTypography>
      </Stack>
    </Stack>
  );

  const programSection = (
    <Stack
      spacing={5}
      justifyContent="center"
      alignItems={"center"}
      sx={{
        width: "100%",
        maxWidth: "100%",
        mx: "auto",
        px: isInappWebview ? 3.5 : 6,
        pt: 6,
        pb: 8,
      }}
    >
      <Stack
        spacing={3}
        sx={{
          width: "100%",
          maxWidth: "660px",
          textAlign: "center",
        }}
      >
        <CustomTypography
          variant={"H1"}
          sx={{
            paddingTop: "54px",
            color: theme.vars.palette.Content.Strong,
            fontWeight: 800,
          }}
        >
          {user?.nickname ? `${user.nickname}님의 프로그램` : "나의 프로그램"}
        </CustomTypography>
        {/* 서브타이틀 문구 변경 */}
        <CustomTypography
          variant={"Subtitle"}
          sx={{
            color: theme.vars.palette.Content.Medium,
            fontWeight: 500,
          }}
        >
          {"마음을 다루는 근거있고\n" + "효과적인 방법을 제안합니다."}
        </CustomTypography>
      </Stack>

      <Stack
        spacing={"12px"}
        sx={{
          width: "100%",
          maxWidth: "660px",
        }}
      >
        <Box
          sx={{
            backgroundColor: theme.vars.palette.Surface.Forward,
            borderRadius: "16px",
            py: 4,
            px: 3,
          }}
        >
          <CustomTypography
            variant={"Body"}
            sx={{
              color: theme.vars.palette.Content.Highlight,
              fontWeight: 700,
            }}
          >
            주요 훈련 계획
          </CustomTypography>
          <Stack spacing={1} sx={{ mt: 2 }}>
            {majorTrainingPlan.map((text, idx) => (
              <Stack
                key={idx}
                direction={"row"}
                spacing={0.5}
                alignItems="center"
              >
                <img src={numberWithCircle[idx]} alt={"number"} style={{}} />
                <CustomTypography
                  variant={"Body"}
                  sx={{
                    p: 0,
                    color: theme.vars.palette.Content.Strong,
                    fontWeight: 500,
                  }}
                >
                  {text}
                </CustomTypography>
              </Stack>
            ))}
          </Stack>
        </Box>

        <Box
          sx={{
            backgroundColor: theme.vars.palette.Surface.Forward,
            borderRadius: "16px",
            py: 4,
            px: 3,
          }}
        >
          <CustomTypography
            variant={"Body"}
            sx={{
              color: theme.vars.palette.Content.Highlight,
              fontWeight: 700,
            }}
          >
            프로그램 구성
          </CustomTypography>
          <Stack spacing={1} sx={{ mt: 2 }}>
            {programFeatures.map(({ main }, idx) => (
              <Stack
                key={idx}
                direction="row"
                alignItems="center"
                spacing={0.5}
              >
                <img src={checkIconImg} alt={"checkImg"} />
                <CustomTypography sx={{ p: 0 }}>
                  <CustomTypography
                    variant={"Body"}
                    sx={{
                      p: 0,
                      color: theme.vars.palette.Content.Strong,
                      fontWeight: 500,
                    }}
                  >
                    {main}
                  </CustomTypography>
                </CustomTypography>
              </Stack>
            ))}
          </Stack>
        </Box>
      </Stack>
    </Stack>
  );

  useEffect(() => {
    setTimeout(() => {
      setFloatingAreaHeight(floatingAreaRef.current?.offsetHeight || 0);
    }, 100);
  }, [floatingAreaRef.current]);

  // 로그인 체크 후 리다이렉트
  useEffect(() => {
    if (!isChecking && !isFetching && !user?.accessToken) {
      navigate(PATH.promotionLogin, { replace: true });
    }
  }, [isChecking, isFetching, user, navigate]);

  // 로딩 중이거나 user 정보가 없으면 CircularProgress 표시
  if (
    isChecking ||
    isFetching ||
    (webTestType?.type !== undefined &&
      webTestType?.type !== "a" &&
      !onboardingQADetailState)
  ) {
    return (
      <ContentTemplateV2
        noPadding
        isWide
        setContainerHeight={setContainerHeight}
      >
        <Stack
          sx={{
            width: "100%",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: theme.vars.palette.Background.Level3,
          }}
        >
          <CircularProgress color="neutral" />
        </Stack>
      </ContentTemplateV2>
    );
  }

  const body = (
    <ContentTemplateV2
      noPadding
      noBottomPaddingChildren
      isWide
      setContainerHeight={setContainerHeight}
    >
      {containerHeight > 0 && (
        <Stack
          sx={{
            backgroundColor: theme.vars.palette.Background.Level3,
          }}
        >
          <Stack
            justifyContent="center"
            alignItems={"center"}
            sx={{
              width: "100%",
              maxWidth: "660px",
              mx: "auto",
            }}
          >
            {/*영역 1: ~님의 프로그램 */}
            {webTestType?.type !== "a"
              ? programSectionWithOnboarding
              : programSection}
            <img
              src={image1}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image2}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image3}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image4}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image5}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />{" "}
            <img
              src={image6}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />{" "}
            <img
              src={image7}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />{" "}
            <img
              src={image8}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image9}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image10}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image11}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image12}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image13}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image14}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image15}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image16}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image17}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image18}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image19}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image20}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
          </Stack>

          <FloatingAreaPromotion
            fullWidth={fullWidth}
            ref={floatingAreaRef}
            noDivider={true}
            backgroundColor={"transparent"}
            paddingBottom={"8px"}
          >
            <Stack
              spacing={1.5}
              sx={{ width: "100%" }}
              alignItems="center"
              justifyContent={"space-between"}
            >
              <Stack
                spacing={"16px"}
                sx={{
                  width: "100%",
                  mx: "auto",
                  paddingBottom: "8px",
                }}
                alignItems="center"
                justifyContent={"space-between"}
              >
                <Button
                  onClick={() => {
                    navigate(PATH.promotionPayment);
                  }}
                  size={"lg"}
                  color={"primary"}
                  sx={{
                    width: "100%",
                    fontWeight: 700,
                  }}
                >
                  {"지금 시작하기"}
                </Button>
              </Stack>
            </Stack>
          </FloatingAreaPromotion>
        </Stack>
      )}
    </ContentTemplateV2>
  );

  return body;
}
